export function downloadCsvWithBom(filename: string, csvText: string) {
  const safeFilename = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  // Strip a leading BOM if the source already has one (e.g. the server-built
  // retry CSV) so the file ends up with exactly one BOM. A double BOM pushes
  // U+FEFF ahead of the first field's opening quote, breaking CSV parsing.
  const body = csvText.startsWith("\uFEFF") ? csvText.slice(1) : csvText;
  const blob = new Blob(["\uFEFF", body], {
    type: "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = safeFilename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
